import './bluefiretotal2/style';
import FormStructure from './bluefiretotal2/form_structure';

export default FormStructure;